import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { AdvisorMessagePropsType } from '../..';

import AvatarRobotPngPath from 'Images/me/pages/guest/proposals/new/avatar_robot.png'
import AvatarRobotWebPPath from 'Images/me/pages/guest/proposals/new/avatar_robot.webp'
import AvatarRobot2xPngPath from 'Images/me/pages/guest/proposals/new/avatar_robot@2x.png'
import AvatarRobot2xWebPPath from 'Images/me/pages/guest/proposals/new/avatar_robot@2x.webp'

type AvatarPropsType = Merge<AdvisorMessagePropsType & {
  isVisibleAvatar: boolean;
}>;

export const Avatar = ({
  avatarName = 'ヌリカエ',
  isVisibleAvatar,
}: AvatarPropsType) => {
  return (
    <div
      css={css`
        ${!isVisibleAvatar && css`
          display: none;
        `}
      `}
    >
      <div
        css={css`
          font-size: 0;
          width: 100%;

          img {
            width: 100%;
            height: auto;
          }
        `}
      >
        <picture>
          <source
            srcSet={`${AvatarRobotWebPPath} 1x, ${AvatarRobot2xWebPPath} 2x`}
            type="image/webp"
          />
          <img
            src={AvatarRobotPngPath}
            srcSet={`${AvatarRobotPngPath} 1x, ${AvatarRobot2xPngPath} 2x`}
            alt={avatarName}
          />
        </picture>
      </div>
    </div>
  );
};
